import './App.css';
import About from './components/about.js';
import Admin from './components/admin.js';
import Dashboard from './components/dashboard.js';
import Events from './components/events.js';
import AdminEvents from './components/adminevents.js';
import Home from './components/home.js';
import Contactussection from './components/contactussection.js';
import ContactUs from './components/contactus.js';
import Subscribe from './components/subscribe.js';
import Aboutuspage from './components/aboutpage.js';
import Login from './components/login.js';
import RsvpForm from './components/RsvpForm.js';
import RsvpForm2 from './components/RsvpForm2.js';
import { Route, Routes } from 'react-router-dom';
import NewsList from './components/NewsList.js';
import BlogDetail from './components/BlogDetail.js';
import RenOnIssue from './components/renonissue.js';
// import Casestudy from './components/casestudy.js';
import ThankYou from './components/ThankYou.js';
// import UnderDevelopment from './components/UnderDevelopment.js';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import EventDetail from './components/eventDetails.js';
import "draft-js/dist/Draft.css";
import Media from './components/media.js';
import VideoDetail from './components/VideoDetail';
import CommunityEventInvite from './components/CommunityEventInvite.js';
import SmsOptIn from './components/SmsOptIn.js';
import PrivacyPolicy from './components/PrivacyPolicy.js';
import RequireAuth from './components/RequireAuth.js';
import { clearSession, redirectToLogin } from './components/AuthCheck.js';


function refreshAccessToken() {
  const refreshToken = localStorage.getItem('refresh_token');
  if (!refreshToken) return;
  fetch((process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/api/token/refresh/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refresh: refreshToken })
  })
    .then(res => res.json())
    .then(data => {
      if (data.access) {
        localStorage.setItem('access_token', data.access);
        return;
      }
      // The refresh token was rejected. Leaving the old access token in place is
      // what let a dead session keep rendering the admin panel.
      clearSession();
      if (window.location.pathname.startsWith('/admin') ||
          window.location.pathname.startsWith('/dashboard')) {
        redirectToLogin();
      }
    })
    .catch(() => { /* offline or server down — keep the session and retry later */ });
}

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
    // Refresh hourly. The comment here used to claim every 4 minutes for a 5
    // minute token; the backend actually issues 365-day access tokens, so this
    // is really a periodic check that the session is still accepted.
    const interval = setInterval(() => {
      refreshAccessToken();
    }, 50 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  
  return (
    <div className="App">
      <Routes>
        <Route path="" element={<Home />} />
        <Route path="/thankyou" element={<ThankYou />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/admin" element={<RequireAuth><Admin /></RequireAuth>} />
        <Route path="/admin/events" element={<RequireAuth><AdminEvents /></RequireAuth>} />
        <Route path="/dashboard/*" element={<RequireAuth><Dashboard /></RequireAuth>} />
        <Route path="/events" element={<Events />} />
        <Route path="/media" element={<Media />} />
  <Route path="/video/:id" element={<VideoDetail />} />
        <Route path="/event-details/:id/" element={<EventDetail />} />
        <Route path="/sms-opt-in" element={<SmsOptIn />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/rsvp" element={<RsvpForm />} />
        <Route path="/invite" element={<CommunityEventInvite />} />
        <Route path="/rsvp2" element={<RsvpForm2 />} />
        <Route path="/login" element={<Login />} />
        <Route path="/Contactussection" element={<Contactussection />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/Subscribe" element={<Subscribe />} />
        <Route path="/Aboutuspage" element={<Aboutuspage />} />
        <Route path="/news" element={<NewsList />} />
        <Route path="/news/:id" element={<BlogDetail />} />
        <Route path="/ren on issue" element={<RenOnIssue />} />
      </Routes>
    </div>
  );
}

export default App;
